import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetalleEspacioPorCerealLinea3Actions'
import { TablaDetalleEspacioPorCerealLinea3View } from '../components/TablaDetalleEspacioPorCerealLinea3View'

class TablaDetalleEspacioPorCerealLinea3 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetalleEspacioPorCerealLinea3View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetalleEspacioPorCerealLinea3)
